import { ReconciliationSpecExcelUploadForm } from '../../components/createReconciliationSpecDraft/ReconciliationSpecExcelUploadForm'
import { UploadVersionButton } from '../../components/uploadVersionButton/UploadVersionButton'
import { useSpecId } from '../../system/useSpecId'

/**
 * Adds a new version to the reconciliation spec in scope by uploading another
 * reconciliation-spec Excel document.
 */
export const ReconciliationSpecUploadVersionButton = () => {
  const specId = useSpecId()

  return (
    <UploadVersionButton
      itemId={specId}
      type="reconciliationSpec"
      formatsConfiguration={[
        {
          renderForm: (formProps) => (
            <ReconciliationSpecExcelUploadForm
              {...formProps}
              expectedSpecName={specId}
            />
          ),
        },
      ]}
    />
  )
}
